export { default as VerticalSvg } from "./layout/vertical.svg";
export { default as HorizontalSvg } from "./layout/horizontal.svg";
export { default as SemiBoxSvg } from "./layout/semibox.svg";

//  dual tone icon

export { default as DSearch } from "./duel-tone/dsearch.svg";
export { default as Session } from "./home/session.svg";
export { default as Eye } from "./home/eye.svg";
export { default as Increase } from "./home/increase.svg";
export { default as Cup } from "./home/cup.svg";
export { default as CupBar } from "./home/cup-bar.svg";
export { default as NoteIcon } from "./home/note.svg";
export { default as Users } from "./home/users.svg";
export { default as Counter } from "./home/counter.svg";
export { default as Docs } from "./home/docs.svg";
export { default as CheckShape } from "./home/check-shape.svg";
export { default as DocsCheck } from "./duel-tone/docs-check.svg";
export { default as DocsArrow } from "./duel-tone/docs-arrow.svg";
export { default as Spam } from "./home/spam.svg";
export { default as Stacks } from "./home/stack.svg";
export { default as CheckMark } from "./home/check-mark.svg";
export { default as Alert2 } from "./home/alert.svg";
export { default as Crown } from "./home/crown.svg";
export { default as Cup1 } from "./duel-tone/cup.svg";
export { default as Bell } from "./duel-tone/bell.svg";
export { default as ColorPalate } from "./duel-tone/color-palater.svg";
export { default as ChartArea } from "./duel-tone/chart-area.svg";
export { default as Building } from "./duel-tone/building.svg";
export { default as Building2 } from "./duel-tone/building-2.svg";
export { default as Sheild } from "./duel-tone/sheild.svg";
export { default as Error } from "./duel-tone/error.svg";
export { default as Diamond } from "./duel-tone/diamond.svg";
export { default as Expand } from "./duel-tone/expand.svg";
export { default as Heroicon } from "./duel-tone/heroicon.svg";
export { default as LucideIcon } from "./duel-tone/lucide-icon.svg";
export { default as CustomIcon } from "./duel-tone/custom-icon.svg";
export { default as VideoLibrary } from "./duel-tone/video-library.svg";

// vector
export { default as BlankVector } from "./man-vector.svg";

// sidebar icon

export { default as DashBoard } from "./duel-tone/dashboard.svg";
export { default as Application } from "./duel-tone/application.svg";
export { default as Authentication } from "./duel-tone/authentication.svg";
export { default as Components } from "./duel-tone/components.svg";
export { default as Grid } from "./duel-tone/grid.svg";
export { default as Stacks2 } from "./duel-tone/stacks.svg";
export { default as Pages } from "./duel-tone/pages.svg";
export { default as Chart } from "./duel-tone/chart.svg";
export { default as Map } from "./duel-tone/map.svg";
export { default as SiteLogo } from "./duel-tone/logo.svg";
export { default as Settings } from "./duel-tone/settings.svg";
export { default as Files } from "./duel-tone/files.svg";
export { default as Graph } from "./duel-tone/graph.svg";
export { default as Cart } from "./duel-tone/cart.svg";
export { default as ClipBoard } from "./duel-tone/clip-board.svg";
export { default as Envelope } from "./duel-tone/envelope.svg";
export { default as Messages } from "./duel-tone/message.svg";
export { default as Monitor } from "./duel-tone/monitor.svg";
export { default as List } from "./duel-tone/list.svg";
export { default as ListFill } from "./duel-tone/list-fill.svg";
export { default as Calendar } from "./duel-tone/calendar.svg";
export { default as Flag } from "./duel-tone/flag.svg";
export { default as Book } from "./duel-tone/book.svg";
export { default as Note } from "./duel-tone/note.svg";
export { default as Medical } from "./duel-tone/medical.svg";
export { default as ClipBoard2 } from "./duel-tone/clip-board2.svg";
export { default as Note2 } from "./duel-tone/note2.svg";
export { default as Note3 } from "./duel-tone/note3.svg";
export { default as BarLeft } from "./duel-tone/bar-left.svg";
export { default as BarTop } from "./duel-tone/bar-top.svg";
export { default as ChartBar } from "./duel-tone/chart-bar.svg";
export { default as PretentionChartLine } from "./duel-tone/pretention-chart-line.svg";
export { default as PretentionChartLine2 } from "./duel-tone/pretention-chart-line2.svg";
export { default as Google } from "./duel-tone/google.svg";
export { default as Pointer } from "./duel-tone/pointer.svg";
export { default as Map2 } from "./duel-tone/map2.svg";
export { default as MenuBar } from "./duel-tone/menu-bar.svg";
export { default as Icons } from "./duel-tone/icons.svg";
export { default as Sun } from "./duel-tone/sun.svg";
export { default as Moon } from "./duel-tone/moon.svg";
export { default as Device } from "./duel-tone/device.svg";

// sidebar icon
export { default as FolderTree } from "./home/foldertree.svg";
